var _classCallCheck = require("/Users/jimmy/Desktop/Jimmy/Work/thailand-golf-association-web-application/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/Users/jimmy/Desktop/Jimmy/Work/thailand-golf-association-web-application/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/Users/jimmy/Desktop/Jimmy/Work/thailand-golf-association-web-application/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _get = require("/Users/jimmy/Desktop/Jimmy/Work/thailand-golf-association-web-application/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");
var _getPrototypeOf = require("/Users/jimmy/Desktop/Jimmy/Work/thailand-golf-association-web-application/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/Users/jimmy/Desktop/Jimmy/Work/thailand-golf-association-web-application/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _wrapNativeSuper = require("/Users/jimmy/Desktop/Jimmy/Work/thailand-golf-association-web-application/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");
var _toConsumableArray = require("/Users/jimmy/Desktop/Jimmy/Work/thailand-golf-association-web-application/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _slicedToArray = require("/Users/jimmy/Desktop/Jimmy/Work/thailand-golf-association-web-application/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("react")) : "function" == typeof define && define.amd ? define(["exports", "react"], t) : t((e = "undefined" != typeof globalThis ? globalThis : e || self)["react-horizontal-scrolling-menu"] = {}, e.React);
}(this, function (e, t) {
  "use strict";

  function n(e) {
    return e && "object" == typeof e && "default" in e ? e : {
      default: e
    };
  }
  var r = n(t);
  !function (e, t) {
    void 0 === t && (t = {});
    var n = t.insertAt;
    if (e && "undefined" != typeof document) {
      var r = document.head || document.getElementsByTagName("head")[0],
        i = document.createElement("style");
      i.type = "text/css", "top" === n && r.firstChild ? r.insertBefore(i, r.firstChild) : r.appendChild(i), i.styleSheet ? i.styleSheet.cssText = e : i.appendChild(document.createTextNode(e));
    }
  }(".react-horizontal-scrolling-menu--wrapper {\n  display: flex;\n}\n\n.react-horizontal-scrolling-menu--scroll-container {\n  display: flex;\n  height: max-content;\n  overflow-y: hidden;\n  position: relative;\n  width: 100%;\n}\n\n:export {\n  wrapper: react-horizontal-scrolling-menu--wrapper;\n  container: react-horizontal-scrolling-menu--scroll-container;\n}\n");
  var i = "react-horizontal-scrolling-menu",
    l = "".concat(i, "--separator"),
    o = "".concat(i, "--item"),
    a = "".concat(i, "--scroll-container"),
    s = "".concat(i, "--wrapper"),
    u = "itemId";
  var d = Object.freeze({
    __proto__: null,
    rootClassName: i,
    separatorClassName: l,
    itemClassName: o,
    scrollContainerClassName: a,
    wrapperClassName: s,
    id: u
  });
  function c(_ref) {
    var e = _ref.children,
      _ref$onScroll = _ref.onScroll,
      t = _ref$onScroll === void 0 ? function () {} : _ref$onScroll,
      n = _ref.scrollRef;
    return r.default.createElement("div", {
      className: a,
      onScroll: t,
      ref: n
    }, e);
  }
  var f = r.default.memo(function (_ref2) {
    var e = _ref2.id,
      t = _ref2.index,
      n = _ref2.refs;
    var i = r.default.useRef(null);
    return n[t] = i, r.default.createElement("div", {
      className: l,
      "data-key": e,
      "data-index": t,
      ref: i
    });
  });
  var v = r.default.memo(function (_ref3) {
    var e = _ref3.children,
      t = _ref3.id,
      n = _ref3.index,
      i = _ref3.refs;
    var l = r.default.useRef(null);
    return i[n] = l, r.default.createElement("div", {
      className: o,
      "data-key": t,
      "data-index": n,
      ref: l
    }, e);
  });
  function m(_ref4) {
    var e = _ref4.children,
      t = _ref4.refs;
    var n = r.default.Children.toArray(e).filter(Boolean),
      i = n.length;
    return r.default.createElement(r.default.Fragment, null, n.map(function (e, n) {
      var l, o;
      var a = null === (o = null === (l = e) || void 0 === l ? void 0 : l.props) || void 0 === o ? void 0 : o[u],
        s = a + "-separator",
        d = n + 1 === i;
      return [r.default.createElement(v, {
        id: a,
        key: "menuItem__" + a,
        refs: t,
        index: n
      }, e), !d && r.default.createElement(f, {
        id: s,
        refs: t,
        key: s,
        index: n + .1
      })];
    }));
  }
  function p(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "smooth";
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "end";
    var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "nearest";
    e && window && window.requestAnimationFrame(function () {
      return e.scrollIntoView({
        block: r,
        behavior: t,
        inline: n
      });
    });
  }
  function h(_ref5) {
    var e = _ref5.items,
      t = _ref5.itemsChanged,
      n = _ref5.refs,
      i = _ref5.options;
    var l = r.default.useRef(),
      _r$default$useState = r.default.useState([]),
      _r$default$useState2 = _slicedToArray(_r$default$useState, 2),
      o = _r$default$useState2[0],
      a = _r$default$useState2[1],
      s = r.default.useRef(+setTimeout(function () {}, 0)),
      u = r.default.useCallback(function (t) {
        var n = function (e, t) {
          return _toConsumableArray(e).map(function (e) {
            var n, r;
            var i = e.target,
              l = (null === (n = null == i ? void 0 : i.dataset) || void 0 === n ? void 0 : n.key) || "";
            return [l, {
              index: String((null === (r = null == i ? void 0 : i.dataset) || void 0 === r ? void 0 : r.index) || ""),
              key: l,
              entry: e,
              visible: e.intersectionRatio >= t.ratio
            }];
          });
        }(t, i);
        e.set(n), global.clearTimeout(s.current), s.current = +setTimeout(function () {
          return global.requestAnimationFrame(function () {
            a(function (t) {
              var n = e.getVisible().map(function (e) {
                return e[1].key;
              });
              return JSON.stringify(t) !== JSON.stringify(n) ? n : t;
            });
          });
        }, i.throttle);
      }, [e, i]);
    return r.default.useLayoutEffect(function () {
      var e = function (e) {
          return Object.values(e).map(function (e) {
            return e.current;
          }).filter(Boolean);
        }(n),
        t = l.current || new IntersectionObserver(u, i);
      return l.current = t, e.forEach(function (e) {
        return t.observe(e);
      }), function () {
        clearTimeout(s.current), t.disconnect(), l.current = void 0;
      };
    }, [u, t, i, n]), {
      visibleItems: o
    };
  }
  var g = /*#__PURE__*/function (_Map) {
    _inherits(g, _Map);
    function g() {
      _classCallCheck(this, g);
      return _possibleConstructorReturn(this, _getPrototypeOf(g).apply(this, arguments));
    }
    _createClass(g, [{
      key: "toArr",
      value: function toArr() {
        return _toConsumableArray(this);
      }
    }, {
      key: "onlyDigits",
      value: function onlyDigits(e) {
        return String(e).replace(/[^0-9.]/g, "");
      }
    }, {
      key: "sort",
      value: function sort(e) {
        var _this = this;
        return e.sort(function (e, t) {
          return +_this.onlyDigits(e[1].index) - +_this.onlyDigits(t[1].index);
        });
      }
    }, {
      key: "set",
      value: function set(e, t) {
        var _this2 = this;
        return Array.isArray(e) ? this.sort(e).forEach(function (e) {
          _get(_getPrototypeOf(g.prototype), "set", _this2).call(_this2, e[0], e[1]);
        }) : _get(_getPrototypeOf(g.prototype), "set", this).call(this, e, t), this;
      }
    }, {
      key: "first",
      value: function first() {
        var e;
        return null === (e = this.toArr()[0]) || void 0 === e ? void 0 : e[1];
      }
    }, {
      key: "last",
      value: function last() {
        var e, t;
        return null === (t = null === (e = this.toArr().slice(-1)) || void 0 === e ? void 0 : e[0]) || void 0 === t ? void 0 : t[1];
      }
    }, {
      key: "filter",
      value: function filter(e) {
        return this.toArr().filter(e);
      }
    }, {
      key: "find",
      value: function find(e) {
        return this.toArr().find(e);
      }
    }, {
      key: "findIndex",
      value: function findIndex(e) {
        return this.toArr().findIndex(e);
      }
    }, {
      key: "prev",
      value: function prev(e) {
        var t;
        var n = this.toArr(),
          r = n.findIndex(function (t) {
            return t[0] === e || t[1] === e;
          });
        return -1 !== r ? null === (t = n[r - 1]) || void 0 === t ? void 0 : t[1] : void 0;
      }
    }, {
      key: "next",
      value: function next(e) {
        var t;
        var n = this.toArr(),
          r = n.findIndex(function (t) {
            return t[0] === e || t[1] === e;
          });
        return -1 !== r ? null === (t = n[r + 1]) || void 0 === t ? void 0 : t[1] : void 0;
      }
    }, {
      key: "getVisible",
      value: function getVisible() {
        return this.filter(function (e) {
          return e[1].visible;
        });
      }
    }]);
    return g;
  }(_wrapNativeSuper(Map));
  var y = {
      ratio: .9,
      rootMargin: "5px",
      threshold: [.05, .5, .75, .95],
      throttle: 100
    },
    b = r.default.createContext({});
  e.ScrollMenu = function (_ref6) {
    var e = _ref6.LeftArrow,
      t = _ref6.RightArrow,
      n = _ref6.children,
      _ref6$onInit = _ref6.onInit,
      i = _ref6$onInit === void 0 ? function () {} : _ref6$onInit,
      l = _ref6.onMouseDown,
      o = _ref6.onMouseUp,
      a = _ref6.onMouseMove,
      _ref6$onScroll = _ref6.onScroll,
      d = _ref6$onScroll === void 0 ? function () {} : _ref6$onScroll,
      _ref6$onWheel = _ref6.onWheel,
      f = _ref6$onWheel === void 0 ? function () {} : _ref6$onWheel,
      _ref6$options = _ref6.options,
      v = _ref6$options === void 0 ? y : _ref6$options,
      _ref6$wrapperClassNam = _ref6.wrapperClassName,
      x = _ref6$wrapperClassNam === void 0 ? "" : _ref6$wrapperClassNam;
    var I = r.default.useRef(null),
      _r$default$useState3 = r.default.useState({}),
      _r$default$useState4 = _slicedToArray(_r$default$useState3, 1),
      C = _r$default$useState4[0],
      S = r.default.useMemo(function () {
        return Object.assign(Object.assign(Object.assign({}, y), v), {
          root: I.current
        });
      }, [v]),
      w = function (e, t) {
        var _r$default$useState5 = r.default.useState(""),
          _r$default$useState6 = _slicedToArray(_r$default$useState5, 2),
          n = _r$default$useState6[0],
          i = _r$default$useState6[1];
        return r.default.useLayoutEffect(function () {
          var t = (e ? r.default.Children.toArray(e).filter(Boolean) : []).map(function (e) {
            var t, n;
            return null === (n = null === (t = e) || void 0 === t ? void 0 : t.props) || void 0 === n ? void 0 : n[u];
          }).filter(Boolean).join("");
          i(t);
        }, [e, t]), n;
      }(n, C),
      E = r.default.useRef(new g()).current,
      _h = h({
        items: E,
        itemsChanged: w,
        options: S,
        refs: C
      }),
      A = _h.visibleItems,
      N = function () {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
        var _r$default$useState7 = r.default.useState(!1),
          _r$default$useState8 = _slicedToArray(_r$default$useState7, 2),
          t = _r$default$useState8[0],
          n = _r$default$useState8[1];
        return r.default.useLayoutEffect(function () {
          t || (n(!0), e());
        }, [e, t]), t;
      }(function () {
        return i(k);
      }),
      M = r.default.useMemo(function () {
        return function (e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
          var n, r;
          var i = t.filter(function (e) {
              return !/separator/.test(String(e));
            }),
            l = !!(null === (n = e.first()) || void 0 === n ? void 0 : n.visible),
            o = !!(null === (r = e.last()) || void 0 === r ? void 0 : r.visible),
            a = function a(t) {
              var n;
              return null === (n = e.find(function (e) {
                return e[1].key === String(t);
              })) || void 0 === n ? void 0 : n[1];
            },
            s = function s() {
              var t, n;
              return e.prev(null === (n = null === (t = e.getVisible()) || void 0 === t ? void 0 : t[0]) || void 0 === n ? void 0 : n[1]);
            },
            u = function u() {
              var t, n, r, i;
              return e.next(null === (i = null === (r = null === (n = null === (t = e.getVisible()) || void 0 === t ? void 0 : t.slice) || void 0 === n ? void 0 : n.call(t, -1)) || void 0 === r ? void 0 : r[0]) || void 0 === i ? void 0 : i[1]);
            };
          return {
            getItemById: a,
            getItemByIndex: function getItemByIndex(t) {
              var n;
              return null === (n = e.find(function (e) {
                return String(e[1].index) === String(t);
              })) || void 0 === n ? void 0 : n[1];
            },
            getNextItem: u,
            getPrevItem: s,
            isFirstItemVisible: l,
            isItemVisible: function isItemVisible(e) {
              var t;
              return Boolean(null === (t = a(e)) || void 0 === t ? void 0 : t.visible);
            },
            isLastItem: function isLastItem(t) {
              return e.last() === a(t);
            },
            isLastItemVisible: o,
            scrollNext: function scrollNext() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "smooth";
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "start";
              var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "nearest";
              var r, i;
              return p(null === (i = null === (r = u()) || void 0 === r ? void 0 : r.entry) || void 0 === i ? void 0 : i.target, e, t, n);
            },
            scrollPrev: function scrollPrev() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "smooth";
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "end";
              var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "nearest";
              var r, i;
              return p(null === (i = null === (r = s()) || void 0 === r ? void 0 : r.entry) || void 0 === i ? void 0 : i.target, e, t, n);
            },
            scrollToItem: p,
            visibleItemsWithoutSeparators: i
          };
        }(E, A);
      }, [E, A]),
      k = r.default.useMemo(function () {
        return Object.assign(Object.assign({}, M), {
          initComplete: N,
          items: E,
          scrollContainer: I,
          visibleItems: A
        });
      }, [M, N, E, A]),
      j = r.default.useCallback(function (e) {
        return d(k, e);
      }, [d, k]),
      O = r.default.useCallback(function (e) {
        return f(k, e);
      }, [f, k]);
    return r.default.createElement("div", {
      className: "".concat(s, " ").concat(x),
      onWheel: O,
      onMouseDown: null == l ? void 0 : l(k),
      onMouseUp: null == o ? void 0 : o(k),
      onMouseMove: null == a ? void 0 : a(k)
    }, r.default.createElement(b.Provider, {
      value: k
    }, e ? r.default.createElement(e, null) : null, r.default.createElement(c, {
      onScroll: j,
      scrollRef: I
    }, r.default.createElement(m, {
      refs: C
    }, n)), t ? r.default.createElement(t, null) : null));
  }, e.VisibilityContext = b, e.constants = d, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});